import ActionBar from "../actionBar.component";
import CreateOrderedPartButton from "../../buttons/parts/createOrderedPart.part.button";
import DefaultButton from "../../buttons/default.button";
import { SelectedOrderedPartsContext } from "../../../contexts/parts/selectedOrderedParts.part.context";
import { useContext, useState } from "react";
import { OrderedPartsContext } from "../../../contexts/parts/orderedParts.context";

const DEFAULT_CLASSNAMES = {
  deleteButton: {
    button:
      "bg-red-500 hover:bg-red-700 shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-4 py-2 text-white",
  },
};

const OrderedPartActionBar = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { deleteOrderedParts, fetchOrderedParts } =
    useContext(OrderedPartsContext);
  const { selectedOrderedParts, resetSelectedOrderedParts } = useContext(
    SelectedOrderedPartsContext
  );
  const handleDeleteManyOrderedParts = () => {
    if (isLoading) return;
    setIsLoading(true);
    if (selectedOrderedParts.length === 0) return;
    deleteOrderedParts(selectedOrderedParts);
    resetSelectedOrderedParts();
    setIsLoading(false);
  };
  return (
    <ActionBar>
      {selectedOrderedParts.length > 0 && (
        <DefaultButton
          loading={isLoading}
          handleClick={handleDeleteManyOrderedParts}
          classNames={DEFAULT_CLASSNAMES.deleteButton}
        >
          Delete {selectedOrderedParts.length}
        </DefaultButton>
      )}
      <CreateOrderedPartButton onClose={fetchOrderedParts} />
      {children}
    </ActionBar>
  );
};

export default OrderedPartActionBar;
